import mixpanel from 'mixpanel-browser';

mixpanel.init(process.env.MIXPANEL, { api_host: 'https://api.mixpanel.com' });

export default mixpanel;
